// @flow
import './ZipCodeContainer.scss';
import Input from '../Input/Input';
import { Typography } from "src/latest/src/components";
import { useState } from 'react';
import MiniCheckBox from '../MiniCheckBox/MiniCheckBox';
import { Card } from 'react-bootstrap';
import DropDownMenu from './../DropDownMenu/DropDownMenu';
import { Countries } from 'src/latest/src';

type Props = {
    question:Object
}

export default function ZipCodeContainer({ question }:Props):React$Element<any> {
    const { choices } = question;
    const [value, setValue] = useState(null);
    const [feedbackMessage, setFeedbackMessage] = useState(null);
    const [isInvalid, setIsInvalid] = useState(false);
    const [checkValue, setCheckValue] = useState('');

    const onChange = (e:Event) => {
        setValue(e.target.value);

        if (e.target.value.length !== 5) {
            setIsInvalid(true);
            setFeedbackMessage('Please enter a valid zip code');
        } else {
            setIsInvalid(false);
            setFeedbackMessage(null);
        }
    };

    return <div className='zipcode-container'>
        <Card className='message-card'>
            <Card.Body>
                <Card.Title className='title'><Typography variant='size-22' weight='semi-bold'>Unfortunately we don't have any providers who are licensed to practice in your state or country at this time.</Typography></Card.Title>
                <Card.Text className='text'><Typography variant='size-16' color='color-10'>We ll inform you once a therapist become available in your area.</Typography></Card.Text>
            </Card.Body>
        </Card>
        <div className='zipcode-checkbox-container'>
            <Typography color='color-28' variant='size-14' className='location mt-4'>Do you currently reside in US ?</Typography>

            <div className='zipcode-checkbox mt-3'>
                <MiniCheckBox onClick={() => setCheckValue('Yes')} checked={checkValue === 'Yes'} text='Yes' />
                <MiniCheckBox onClick={() => setCheckValue('No')} checked={checkValue === 'No'} text='No' />
            </div>
        </div>
        {
            checkValue === 'Yes' && <div className='input mt-3'>
                {choices && choices.map((choice) => <Input key={choice.id} placeholder={choice.place_holder} value={value}
                    infoMessage={question.info_message} isInvalid={isInvalid} feedbackMessage={feedbackMessage}
                    onChange={onChange}/>)
                }
                <Typography color='color-28' variant='size-14' className='location mt-3'>Greenboro, VT</Typography>
            </div>
        }
        {
            checkValue === 'No' && <DropDownMenu menu={Countries}/>
        }
    </div>;
}
